import { useRouter } from "next/router";

import { SOCIAL_LINKS } from "@enkor/external-links";

import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";
import WebViewBridge from "@logics/utils/webViewBridge";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";
import { APP_SIZE } from "@styles/variables";

import * as S from "./StayIntroduction.style";

export const stayIntroductionThumbnailImage =
  "https://enkor-fip-prod.s3.ap-northeast-2.amazonaws.com/defaultImage/hyundai-sinchon-thumbnail.png";

export const stayIntroductionImageSources = [
  "https://enkor-fip-prod.s3.ap-northeast-2.amazonaws.com/defaultImage/hyundai-sinchon-content.png",
];

export const STAY_UTM_LINK =
  "https://stay.enkor.kr?utm_source=letsfip&utm_medium=bridge&utm_campaign=stayislife&utm_term=rent";

const StayIntroduction = () => {
  const { back, push } = useRouter();

  const handleBack = () => {
    if (WebViewBridge.isInAppWebView()) {
      WebViewBridge.getInstance().navigateBack();
      return;
    }

    if (window.history.length > 1) {
      back();
    } else {
      push(NAVIGATION_ROUTE.EVENT_LIST.HREF);
    }
  };

  const openEnkorStay = () => {
    WebViewBridge.getInstance().triggerOpenLinkWebView(SOCIAL_LINKS.ENKOR_STAY);
  };

  const handleClickLink = (link: string) => {
    WebViewBridge.getInstance().triggerOpenLinkWebView(link);
  };

  return (
    <StackLayout
      isFixedNavbar
      navbar={{
        iconType: "CHEVRON_LEFT",
        onClickIcon: handleBack,
        title: "Sinchon Hyundai x Enkostay 🎉",
      }}
    >
      <S.Container>
        <S.ImageWrapper>
          <S.ImageContent
            src={stayIntroductionImageSources[0]}
            alt="introduction image - 1"
            width={0}
            height={0}
            sizes={`${APP_SIZE.MAX_WIDTH}px`}
          />
        </S.ImageWrapper>
      </S.Container>

      {/* MEMO: 하단 버튼 주석 처리 */}
      {/* <S.BottomButtonBox>
        <S.StyledButton onClick={openEnkorStay}>
          Find accommodations at Enkorstay
        </S.StyledButton>
      </S.BottomButtonBox> */}
    </StackLayout>
  );
};

export default StayIntroduction;
